<ol class="lv-meldungbox" *ngIf="meldungen && meldungen.length">
  <li class="lv-meldungbox-list-item" *ngFor="let meldung of meldungen | meldung: 'Fehler' trackBy: trackByFn">
        <span [innerHTML]="meldung.Meldungstext"></span>
   </li>
  <li class="lv-meldungbox-list-item" *ngFor="let meldung of meldungen | meldung: 'Warnung' trackBy: trackByFn">
        <span [innerHTML]="meldung.Meldungstext"></span>
  </li>
  <li class="lv-meldungbox-list-item" *ngFor="let meldung of meldungen | meldung: 'Info' trackBy: trackByFn">
        <span [innerHTML]="meldung.Meldungstext"></span>
  </li>
</ol>
